import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const textIconButtonVariants = cva(
  [
    'group flex items-center justify-center rounded-lg bg-secondary text-sm focus-ring',
    'text-foreground-subtle',
    '[&>span]:hidden [&>span]:data-[active=true]:inline',
    'data-[active=true]:w-auto data-[active=true]:text-foreground',
    'aria-expanded:bg-secondary-hover aria-expanded:text-foreground',
  ],
  {
    variants: {
      variant: {
        outline: [
          'border border-border-strong bg-transparent hover:text-foreground',
          'data-[active=true]:bg-surface-active',
          'data-[active=true]:aria-expanded:bg-surface-active',
        ],
      },
    },
    defaultVariants: {
      variant: 'outline',
    },
  }
);

type TextIconButtonProps = VariantProps<typeof textIconButtonVariants> &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

export const TextIconButtonRoot = ({
  children,
  className,
  variant,
  ...props
}: TextIconButtonProps) => {
  return (
    <button
      className={cn(textIconButtonVariants({ variant }), className)}
      {...props}
    >
      {children}
    </button>
  );
};

export const TextIconButtonIcon = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="flex items-center justify-center p-1.5 size-7">
      <div className="[&>svg]:size-4">{children}</div>
    </div>
  );
};

export const TextIconButtonText = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <span className="pr-2 select-none">{children}</span>;
};
